import { type RefObject, useEffect, useRef, useState } from 'react';

import { useHeaderLayoutStore } from '../../../shared';

export function useMobileMenu() {
    const [isOpen, setIsOpen] = useState(false);
    const triggerRef = useRef<HTMLButtonElement>(null) as RefObject<HTMLButtonElement>;
    const isDesktopMenu = useHeaderLayoutStore(state => state.isDesktopMenu);

    const openMenu = () => setIsOpen(true);

    const closeMenu = () => setIsOpen(false);

    // CSS switches the visible Menu without unmounting either tree.
    // The drawer is portaled outside that tree, so CSS cannot close it when Mobile becomes hidden.
    useEffect(() => {
        if (isDesktopMenu) setIsOpen(false);
    }, [isDesktopMenu]);

    const handleOpenChangeComplete = (isNowOpen: boolean) => {
        if (isNowOpen) return;

        requestAnimationFrame(() => {
            const trigger = triggerRef.current;
            if (trigger?.getClientRects().length) trigger.focus();
        });
    };

    return {
        closeMenu,
        isOpen,
        handleOpenChangeComplete,
        openMenu,
        setIsOpen,
        triggerRef,
    };
}
